import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export interface AddProductGroupRequest {
  id?: number;
  name: string;
  status: "ACTIVE" | "PASSIVE" | "FAIL" | "PENDING" | "VOID" | "START" | "SUCCESS" | "REFUND" | "EXPIRED" | "BLOCKED" | "DELETED" | "BLACKLISTED";
}

export type AddProductGroupResponse = BaseResponse<null>;

async function addProductGroup(
  data: AddProductGroupRequest
): Promise<AddProductGroupResponse> {
  try {
    return (await axiosInstance.post("/Product/AddProductGroup", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddProductGroup() {
  return useMutation<AddProductGroupResponse, Error, AddProductGroupRequest>(
    (variables) => addProductGroup(variables)
  );
}
